import React, { useState } from 'react';
import VouchersForm from './VouchersForm';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Vouchers } from '../../../../../../../constants/APIs';
import PropTypes from 'prop-types';
import BuyOptionForm from './BuyoptionForm';
export default function UpdateVouchersForm({ id, propertyId, optionId, isBuyOption, extractData }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [isBuyOptionForm, setisBuyOptionForm] = useState(false);
  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Vouchers}/${id}`,
      data: formmatedData,
    }).then(() => {
      extractData();
      if (isBuyOption) {
        setisBuyOptionForm(!isBuyOptionForm);
      } else {
        setIsUpdating(!isUpdating);
      }
    });
  };
  return (
    <div>
      {isBuyOption ? <Button
        color="primary"
        size="xs"
        onClick={() => setisBuyOptionForm(!isBuyOptionForm)}
      >
        Edit
      </Button> :
        <Button
          color="primary"
          size="xs"
          onClick={() => setIsUpdating(!isUpdating)}
        >
          Edit
        </Button>}
      {isUpdating && (
        <VouchersForm
          formLabel="Update the Voucher"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          propertyId={propertyId}
        />
      )}
      {isBuyOptionForm && (<BuyOptionForm
        formLabel="Update the Voucher Buy Option"
        visible={isBuyOptionForm}
        toggle={() => {
          setisBuyOptionForm(!isBuyOptionForm);
        }}
        id={id}
        optionId={optionId}
        submit={handleSubmit}
        propertyId={propertyId}
        extractData={extractData}
        update={true}
      />)}
    </div>
  );
}

UpdateVouchersForm.propTypes = {
  id: PropTypes.string.isRequired,
};
